<template>
  <blockquote ref="blockquoteRef" class="overflow-hidden">
    <slot />
  </blockquote>
</template>

<script setup lang="ts">
import type { NodeProps } from './RenderNode.vue';
import { ref, onMounted, nextTick } from 'vue';
import { gsap } from 'gsap';
import { SplitText } from 'gsap/SplitText';
import { useIntersectionObserver } from '@vueuse/core';

gsap.registerPlugin(SplitText);

defineProps<NodeProps>();

const blockquoteRef = ref<HTMLElement>();
let splitText: SplitText | null = null;

onMounted(async () => {
  await nextTick();
  if (!blockquoteRef.value) return;

  splitText = new SplitText(blockquoteRef.value, { type: 'words' });
  gsap.set(splitText.words, { color: '#333', opacity: 0.6 });

  useIntersectionObserver(
    blockquoteRef,
    ([{ isIntersecting }]) => {
      if (isIntersecting && splitText) {
        splitText.words.forEach((word, i) => {
          gsap.delayedCall(i * 0.2, () => {
            gsap.set(word, { color: '#fff', opacity: 1 });
          });
        });
      }
    },
    { threshold: 1 },
  );
});
</script>
